import React from 'react';

import styles from './daily-fee.module.scss';

interface Props {
  ageRange: string;
  dailyRate: string;
}

const DailyFee = (props: Props): JSX.Element => {
  const { ageRange, dailyRate } = props;
  return (
    <div className={styles.dailyFee}>
      <h2>Daily Fee</h2>
      <p>
        Our daily fee for children in our {ageRange} year program is{' '}
        <strong>{dailyRate} per day</strong>.
      </p>
      <p className={styles.feeNote}>
        Fees effective July 2026. Child Care Subsidy (CCS) may apply to eligible
        families.
      </p>
    </div>
  );
};

export default DailyFee;
